var React = require('react');

function BlogPostsBgTriangleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M49.5223 46.051L73.9374 1.90586L101.929 75.5774L49.5223 46.051Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M0.945906 44.6949L74.02 1.90902L49.6149 45.9873L0.945906 44.6949Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M0.949219 44.6992L49.5839 45.9908L101.932 75.5828L0.949219 44.6992Z","fill":"#5915C7","key":2})]);
}

BlogPostsBgTriangleMobile.defaultProps = {"width":"104","height":"76","viewBox":"0 0 104 76","fill":"none"};

module.exports = BlogPostsBgTriangleMobile;

BlogPostsBgTriangleMobile.default = BlogPostsBgTriangleMobile;
